import React, { useState } from 'react';

export default function WbsToolbar({
    reorderDirty,
    dirtyContentCount,
    // onSaveReorder,
    onSaveContent,
    onAddSameLevel,
    onAddChild,
    onPublish,
    onRefresh,
    // onOpenImport,
    onOpenExport,
    //추가
    insertMode,
    onChangeInsertMode,
    onRebuildHierarchy,
    // 추가
    // versions,
    // currentVersion,
    // onActivateVersion,
    previewOn,
    onTogglePreview,
    scheduleMode,
    onToggleScheduleMode,
    canPublish,
    showDiscardDraft,
    onDiscardDraft,
    onExitEditor,
}: {
    reorderDirty: boolean;
    dirtyContentCount: number;
    // onSaveReorder: () => void;
    onSaveContent: () => void;
    onAddSameLevel: () => void;
    onAddChild: () => void;
    onPublish: () => void;
    onRefresh: () => void;
    // onOpenImport: () => void;
    onOpenExport: () => void;
    // 추가
    insertMode: 'append' | 'reassign';
    onChangeInsertMode: (m: 'append' | 'reassign') => void;
    onRebuildHierarchy: () => void;
    // 추가
    // versions: Array<{ version: number; isCurrent: boolean }>;
    // currentVersion: number | null;
    // onActivateVersion: (v: number) => void;
    previewOn: boolean;
    onTogglePreview: () => void;
    scheduleMode: boolean;
    onToggleScheduleMode: () => void;
    canPublish: boolean;
    showDiscardDraft?: boolean;
    onDiscardDraft?: () => void;
    onExitEditor: () => void;
}) {
    return (
        <div className="text-sm bg-white border rounded-xl p-2 flex items-center gap-2">
            <div className="flex items-center gap-2">
                {/* <label className="ml-2 inline-flex items-center gap-1 text-sm">
                    <input
                        type="checkbox"
                        checked={insertMode === 'reassign'}
                        onChange={(e) => onChangeInsertMode(e.target.checked ? 'reassign' : 'append')}
                    />
                    <span>계층번호 새로부여</span>
                </label> */}

                {/* [추가] 계층코드 재생성 버튼 */}
                {/* 프론트에서 일단 없애는 것으로 결정. 화면에서 숨김 */}
                <button
                    className="px-3 py-1 rounded border"
                    onClick={onRebuildHierarchy}
                    title="draft의 code/level을 서버에서 재계산하여 DB에 저장합니다."
                >
                    계층코드 생성
                </button>
                {/* <button
                    type="button"
                    className='px-3 py-1 rounded border'
                    onClick={onTogglePreview}
                    title="DB에는 저장하지 않고 화면에만 미리 계산된 코드를 표시합니다."
                >
                    {previewOn ? '미리보기 끄기' : '계층코드 미리보기'}
                </button> */}
                {/* 계층코드 미리보기 버튼 */}
                {/* <label className="ml-2 inline-flex items-center gap-1 text-sm">
                    <input type="checkbox" checked={previewOn} onChange={onTogglePreview} />
                    <span>계층코드 미리보기</span>
                </label> */}

                {/* 엑셀 임포트 버튼 */}
                {/* <button
                    className="px-3 py-1 rounded border"
                    onClick={onOpenImport}
                    title="Excel 파일로 WBS를 일괄 생성합니다."
                    type="button"
                >
                    Import from Excel
                </button> */}

                {/* 엑셀 내보내기 버튼 */}
                <button
                    className="px-3 py-1 rounded border"
                    onClick={onOpenExport}
                    title="현재 WBS를 Excel 파일로 내보냅니다."
                    type="button"
                >
                    Export to Excel
                </button>

                {/* 일정계획 모드 버튼 */}
                <label className="ml-2 inline-flex items-center gap-1 text-sm">
                    <input type="checkbox" checked={scheduleMode} onChange={onToggleScheduleMode} />
                    <span>일정계획 모드</span>
                </label>
            </div>
            {/* <button
                className={`px-3 py-1 rounded border ${
                    reorderDirty ? 'border-orange-500 text-orange-600' : 'opacity-50 cursor-not-allowed'
                }`}
                onClick={onSaveReorder}
                disabled={!reorderDirty}
                title={reorderDirty ? '형제 순서 변경을 서버에 저장합니다.' : '변경된 순서가 없습니다.'}
            >
                계층코드 재생성
            </button> */}

            {/* <button
                className={`px-3 py-1 rounded border ${
                    dirtyContentCount > 0 ? 'border-blue-500 text-blue-600' : 'opacity-50 cursor-not-allowed'
                }`}
                onClick={onSaveContent}
                disabled={dirtyContentCount === 0}
                title={
                    dirtyContentCount > 0 ? '수정된 내용(이름/날짜/메모 등)을 저장합니다.' : '변경된 내용이 없습니다.'
                }
            >
                저장
            </button> */}

            <div className="ml-24 flex items-center gap-2">
                <button className="px-3 py-1 rounded border" onClick={onAddSameLevel}>
                    같은 레벨에 추가
                </button>
                <button className="px-3 py-1 rounded border" onClick={onAddChild}>
                    하위 레벨에 추가
                </button>
            </div>

            <div className="flex-1" />

            <button className="px-3 py-1 rounded border" onClick={onRefresh} title="서버에서 다시 불러오기">
                새로고침
            </button>

            {showDiscardDraft && (
                <button
                    className="px-3 py-1 rounded border border-rose-200 text-rose-700 hover:bg-rose-50"
                    onClick={onDiscardDraft}
                    type="button"
                >
                    초안 폐기
                </button>
            )}
            <button
                className="px-3 py-1 rounded border border-green-500 text-green-600"
                onClick={() => {
                    if (!canPublish) return;
                    onPublish();
                }}
                title={canPublish ? '드래프트를 퍼블리시(새 버전 생성)' : '게시할 수 없습니다.'}
                disabled={!canPublish}
            >
                Publish
            </button>
            <button
                className="px-3 py-1 rounded border bg-gray-50 hover:bg-gray-100"
                onClick={onExitEditor}
                type="button"
            >
                Wbs Editor에서 나가기
            </button>
        </div>
    );
}
